import React from "react";
import WithCard from "../withCard";
import Spinner from "../spinner";

const SpinnerWithCard = () => (
  <WithCard>
    <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div className="d-flex justify-content-center">
          <Spinner />
        </div>
      </div>
    </div>
  </WithCard>
);

export default SpinnerWithCard;



// WEBPACK FOOTER //
// ./src/components/common/spinnerWithCard/SpinnerWithCard.js